import { createStore } from "vuex";
import { VuexModule } from "vuex-class-modules";

VuexModule.__useHotUpdate = import.meta.env.DEV;

export default createStore({});
